var AbstractView = require("../common/AbstractView");
var Utils = require("common/Utils");

/**
 * Base View for displaying the actions available on a file in a VFS
 *
 * @constructor
 * @implements AbstractView
 */
function VFSFileActionView() {
    var $content = $(require("html!./vfs_file_actions_view.html"));
    var currentFile;
    var currentPath;
    var currentTransferUri;
    var self = this;

    var $downloadButton = $('<a href="#" data-role="button" data-icon="mobile-download" data-iconpos="notext" data-inline="true">');
    var $deleteButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-delete" data-iconpos="notext" data-inline="true">');
    var $renameButton = $('<a href="#" rel="external" data-role="button" data-icon="mobile-rename" data-iconpos="notext" data-inline="true">');
    var $progressBar = $content.find("#fileDownloadProgress");
    var $progressBarInner = $progressBar.find(".progressBar div");
    var $largeFileIcon = $content.find(".vfsLargeFileIcon");
    var $cancelDownloadButton = $content.find("#fileDownloadCancel");

    function onDownloadFile(event, autoOpen) {
        if (!currentTransferUri) {
            self.publishEvent("VFSController", "download-file", {autoOpen : autoOpen});
        }
        event.preventDefault();
    }

    $downloadButton.on("click", function(event) {
        onDownloadFile(event, false);
    });

    $largeFileIcon.on("click", function(event) {
        onDownloadFile(event, true);
    });

    $cancelDownloadButton.on("click", function() {
        self.publishEvent("VFSController", "cancel-transfer", {transferId : currentTransferUri});
    });

    $deleteButton.on("click", function() {
        self.publishEvent("VFSController", "delete-file-folder", {
            target : currentPath
        });
    });

    $renameButton.on("click", function() {
        self.publishEvent("VFSController", "show-rename-dialog", {
            target : currentPath
        });
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "VFSFileAction";
    };

    /**
     * @override
     * @returns {jQuery} The jQuery element containing the content of this view
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @returns {DefaultHeader~Configuration} The header configuration for this view
     */
    this.getHeaderConfiguration = function() {
        return {
            title : (currentFile ? currentFile.name : ""),
            overflowButtons : {
                "common::vfs.renameFileFolder.title" : $renameButton,
                "common::vfs.deleteConfirmation.title" : $deleteButton,
                "common::vfs.download.title" : $downloadButton
            },
            overflowClasses : "vfsHeader"
        };
    };

    this.setFile = function(file, path, transferDetails) {
        currentFile = file;
        currentPath = path;

        var dotIndex = file.name.lastIndexOf(".");
        var fileSuffix = (dotIndex === -1) ? "file" : file.name.substr(dotIndex + 1).toLowerCase();

        $largeFileIcon.attr("data-filetype", fileSuffix);
        $content.find("#vfsFilename").text(file.name);
        $content.find("#vfsFilesize").text(Utils.formatBytesAsString(file.size));

        $progressBar.css("visibility", "hidden");
        $progressBarInner.css("width", 0);

        Utils.setElementEnabled($downloadButton, true);
        Utils.setElementEnabled($largeFileIcon, true);
        $downloadButton.css("display", "inline-block");

        if (transferDetails) {
            this.setDownloadProgress(transferDetails, false);
        } else {
            currentTransferUri = undefined;
        }
    };

    this.setDownloadProgress = function(transferDetails, animate) {
        if (transferDetails.status === "transferring") {
            currentTransferUri = transferDetails.transferId;
            Utils.setElementEnabled($downloadButton, false);
            Utils.setElementEnabled($largeFileIcon, false);

            $progressBar.css("visibility", "");
            var progress = Math.min(100, transferDetails.progress);

            if (animate && transferDetails.progress > 0) {
                $progressBarInner.animate({width : progress + "%"}, 300);
            } else {
                $progressBarInner.css("width", progress + "%");
            }
        } else {
            currentTransferUri = undefined;
            Utils.setElementEnabled($downloadButton, true);
            Utils.setElementEnabled($largeFileIcon, true);

            $progressBar.css("visibility", "hidden");
            $progressBarInner.css("width", 0);
        }
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "vfs";
    };
}

VFSFileActionView.prototype = AbstractView;

module.exports = VFSFileActionView;